import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { EnvProvider, loadEnvName } from './config/env';
import { VENUE_PARAM } from './venue/scope';
import { venueStore } from './venue/useVenueScope';
import { HlProvider } from './hl/react';
import App from './App';
import { initI18n } from './i18n/i18n';
import GeoGate from './geo/GeoGate';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    // retry: false (#1809): InfoClient is the one retry layer, a TanStack retry would multiply its attempts.
    queries: { refetchOnWindowFocus: false, retry: false, staleTime: 5_000 },
  },
});

// ?venue=<id>|all testing override (#689): apply before the first render (VenueUrlSync then tidies the URL).
venueStore.applyUrl(loadEnvName(), new URLSearchParams(window.location.search).get(VENUE_PARAM));

const root = document.getElementById('root');
if (!root) throw new Error('#root missing');

// #799: load the starting language (lazy chunk unless English) before the first render: no English flash.
void initI18n().finally(() =>
  createRoot(root).render(
    <StrictMode>
      <EnvProvider>
        <QueryClientProvider client={queryClient}>
          <HlProvider>
            <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
              <GeoGate>
                <App />
              </GeoGate>
            </BrowserRouter>
          </HlProvider>
        </QueryClientProvider>
      </EnvProvider>
    </StrictMode>,
  ),
);
